import { memo } from "react";
import Feedback from "ui/forms/Feedback";
import useMerchantFeedback from "./useMerchantFeedback";

const MerchantFeedback = () => (
    <Feedback
        {...useMerchantFeedback()}
    />
);

export default memo(MerchantFeedback);
